import { Grid, Typography, Stack, Box } from "@mui/material"
import { catalogs } from "../../../utils/catalogs"
import CountdownTimer from "../CountdownTimer"
import MobileSteps from "../MobileSteps"
import PhoneCodeInput from "../PhoneCodeInput"
import ContainedButton from "../../actions/ContainedButton"
import CeluHeader from "./CeluHeader"
import DisplayError from "../DisplayError"


const VerificationCodeView = ({
    code='',
    method,
    stepper,
    email,
    mobile,
    loading,
    error,
    onUpdatePhoneCode,
    onRequestVerificationCode, 
    onConfirmCode,
    mobileCountry,
    onChangeRegistrationMethod,
    onReturn
}) => {

    const valid = code.length === 6

    let countryCode = '+52'
    if(mobile){
        const code = catalogs.mobile_country_codes.find(el => el.value == mobileCountry)
        if(code) countryCode = code?.label
    }

    console.log(error)

    return(
        <div >
            <CeluHeader
                title='Código de verificación'
                enable_return onReturn={onReturn} 
            />
            <Grid container justifyContent="center" sx={{mt:5}}>
                <Grid item>
                    <PhoneCodeInput
                        value={code} 
                        onChange={onUpdatePhoneCode}
                        onSubmit={onConfirmCode} 
                    />
                </Grid>
            </Grid>
            <Typography>Introduce el código enviado a</Typography>
            {method == 'email' && <Typography variant='subtitle2'>{email ?? ''}</Typography>}
            {method !== 'email' && <Typography variant='subtitle2'>{countryCode} {mobile ?? ''}</Typography>}
            <Box
                sx={{
                    my:5,
                    minHeight:150
                }}
            >
                <Stack alignItems='center'>
                    <div >
                        <CountdownTimer 
                            hoursMinSecs={{hours:0, minutes: 0, seconds: 60}} 
                            onRequestVerificationCode={onRequestVerificationCode} 
                        />
                    </div>
                    {/*<Box
                        sx={{py:3}}
                    >
                        <Typography align="center">
                            ¿No recibiste ningún código?
                        </Typography>
                        <div onClick={onChangeRegistrationMethod} style={{cursor:'pointer'}}>
                            <Typography variant='subtitle2'>otras opciones de verificación</Typography>
                        </div>
            </Box>*/}
                </Stack>
            </Box>
            
            <MobileSteps
                position={stepper?.position ?? 0}
                steps={stepper?.steps ?? 1}
            />
            <DisplayError text={error}>{error?.message}</DisplayError>
            <ContainedButton fullWidth
            disabled={!valid} 
            loading={loading}
            onClick={onConfirmCode}
            >Confirmar</ContainedButton>
        </div>
    )

}

export default VerificationCodeView